import { persistor } from '@shared/redux';

let ready = false;
let waiter: Promise<void> | null = null;

export function waitRehydration(): Promise<void> {
  if (ready) return Promise.resolve();

  if (!waiter) {
    waiter = new Promise<void>((resolve) => {
      const check = () => {
        const s = persistor.getState?.();
        if (s?.bootstrapped) {
          ready = true;
          resolve();
          unsubscribe?.();
        }
      };
      const unsubscribe = persistor.subscribe?.(check);
      check();
    });
  }
  return waiter;
}
